import { z } from "zod";

// Region options
export const REGION_OPTIONS = [
  { value: "mena", label: "MENA" },
  { value: "europe", label: "Europe" },
  { value: "north_america", label: "North America" },
  { value: "asia_pacific", label: "Asia Pacific" },
  { value: "latin_america", label: "Latin America" },
  { value: "africa", label: "Africa" },
] as const;

// Team options
export const TEAM_OPTIONS = [
  { value: "corporate", label: "Corporate" },
  { value: "litigation", label: "Litigation" },
  { value: "ip", label: "Intellectual Property" },
  { value: "regulatory", label: "Regulatory" },
  { value: "employment", label: "Employment" },
  { value: "real_estate", label: "Real Estate" },
  { value: "tax", label: "Tax" },
  { value: "banking", label: "Banking & Finance" },
] as const;

// Define the schema for the summary form
export const summaryFormSchema = z.object({
  title: z.string().min(1, {
    message: "Title is required",
  }),
  matterName: z.string().min(1, {
    message: "Matter Name is required",
  }),
  region: z.string().min(1, {
    message: "Region is required",
  }),
  team: z.string().min(1, {
    message: "Team is required",
  }),
  description: z.string().min(10, {
    message: "Description must be at least 10 characters",
  }),
  includeCompanyInfo: z.boolean().default(false),
});

// Define type for the form values
export type SummaryFormValues = z.infer<typeof summaryFormSchema>;

// Default values for the forms
export const summaryDefaultValues: Partial<SummaryFormValues> = {
  title: "",
  matterName: "",
  region: "",
  team: "",
  description: "",
  includeCompanyInfo: false,
};
